import React, { SVGProps } from "react";

export const FileIcon = ({ className, color, style, ...props }: SVGProps<SVGSVGElement> & { color?: string }) => (
  <svg viewBox="0 0 24 24" fill="none" width={20} height={20} className={className} style={style} {...props}>
    <path
      d="M6 2h9l5 5v13a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2Z"
      stroke={color ?? "currentColor"}
      strokeWidth="2"
    />
    <path d="M14 2v6h6" stroke={color ?? "currentColor"} strokeWidth="2" />
    <path d="M8 13h8M8 17h5" stroke={color ?? "currentColor"} strokeWidth="2" />
  </svg>
);

export default FileIcon;
